import React from 'react';
import { Pagination } from 'antd';
const PaginationCommon = ({ totalRecord, pageSize = 10, pageIndex, setPageSize, setPageIndex }) => {
    const handlePageChange = (page, pageSize) => {
        setPageIndex(page);
        setPageSize(pageSize);
    };
    return (
        <Pagination
            total={totalRecord}
            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
            pageSize={pageSize}
            current={pageIndex}
            onChange={handlePageChange}
            showSizeChanger
            pageSizeOptions={[10, 30, 50]}
        />
    );
}
export default PaginationCommon;